import React from "react";
import {
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  BarChart,
  LabelList,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";

const Dashboard = () => {
  const dataPie = [
    { name: "Retrasado", value: 300 },
    { name: "Transito", value: 300 },
    { name: "Arribado", value: 300 },
  ];
  const COLORS = ["#c8c8c8", "#fecc11", "#41bda5"];

  const dataMixBarchart = [
    {
      name: "SOS 1",
      retrasado: 4000,
      transito: 2400,
      arribado: 2400,
    },
    {
      name: "SOS 2",
      retrasado: 3000,
      transito: 1398,
      arribado: 2210,
    },
    {
      name: "SOS 3",
      retrasado: 2000,
      transito: 2000,
      arribado: 2290,
    },
    {
      name: "SOS 4",
      retrasado: 2780,
      transito: 3908,
      arribado: 2000,
    },
    {
      name: "SOS 5",
      retrasado: 18,
      transito: 4800,
      arribado: 2181,
    },
    {
      name: "SOS 6",
      retrasado: 2390,
      transito: 3800,
      arribado: 2500,
    },
    {
      name: "SOS 7",
      retrasado: 3490,
      transito: 4300,
      arribado: 2100,
    },
  ];

  const dataVerticalChart = [
    {
      name: "SOS A",
      percent: 50,
    },
    {
      name: "SOS B",
      percent: 70,
    },
    {
      name: "SOS C",
      percent: 76,
    },
    {
      name: "SOS D",
      percent: 10,
    },
    {
      name: "SOS E",
      percent: 30,
    },
    {
      name: "SOS F",
      percent: 40,
    },
    {
      name: "SOS G",
      percent: 68,
    },
  ];

  const CustomizedLabel = (props) => {
    const { x, y, value, width } = props;

    return (
      <text
        x={x + width + 20}
        y={y}
        dy={15}
        fill="#4988a6"
        fontSize={14}
        textAnchor="middle"
      >
        {value + "%"}
      </text>
    );
  };

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius - 24) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        fontWeight="bold"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div>
      <br />
      <br />
      <br />
      <br />
      <nav className="level is-mobile">
        <div className="level-left">
          <div className="level-item">
            <p className="is-size-4 has-text-grey">
              <b>Reportes</b>
            </p>
          </div>
        </div>

        <div className="level-right">
          <p
            className="level-item is-size-6 has-text-grey"
            style={{ marginRight: "40px" }}
          >
            <i>Ordenar por:</i>
          </p>
          <div className="level-item" style={{ marginRight: "40px" }}>
            <label className="checkbox is-size-6 has-text-grey">
              <input type="checkbox" style={{ marginRight: "10px" }} />
              <i>En transito</i>
            </label>
          </div>

          <div className="level-item" style={{ marginRight: "40px" }}>
            <label className="checkbox is-size-6 has-text-grey">
              <input type="checkbox" style={{ marginRight: "10px" }} />
              <i>Arribado</i>
            </label>
          </div>

          <div className="level-item">
            <label className="checkbox is-size-6 has-text-grey">
              <input type="checkbox" style={{ marginRight: "10px" }} />
              <i>Retrasado</i>
            </label>
          </div>
        </div>
      </nav>

      <div
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "3rem",
        }}
      >
        <nav className="level">
          <div
            className="level-item has-background-white"
            style={{ marginRight: "10px", marginLeft: "10px" }}
          >
            <div
              className="columns is-mobile"
              style={{ width: "100%", padding: "10px" }}
            >
              <div className="column is-4">
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius: "4px",
                    backgroundColor: "#fecc11",
                  }}
                ></div>
              </div>

              <div className="column has-text-left is-8">
                <p className="is-size-6 has-text-grey">
                  <b>
                    <i>En Transito</i>
                  </b>
                </p>
                <p className="is-size-5 has-text-grey">
                  <b>454 paquetes</b>
                </p>
              </div>
            </div>
          </div>

          <div
            className="level-item has-background-white"
            style={{ marginRight: "10px", marginLeft: "10px" }}
          >
            <div
              className="columns is-mobile"
              style={{ width: "100%", padding: "10px" }}
            >
              <div className="column is-4">
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius: "4px",
                    backgroundColor: "#41bda5",
                  }}
                ></div>
              </div>

              <div className="column has-text-left is-8">
                <p className="is-size-6 has-text-grey">
                  <b>
                    <i>En Transito</i>
                  </b>
                </p>
                <p className="is-size-5 has-text-grey">
                  <b>454 paquetes</b>
                </p>
              </div>
            </div>
          </div>

          <div
            className="level-item has-background-white"
            style={{ marginRight: "10px", marginLeft: "10px" }}
          >
            <div
              className="columns is-mobile"
              style={{ width: "100%", padding: "10px" }}
            >
              <div className="column is-4">
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius: "4px",
                    backgroundColor: "#c8c8c8",
                  }}
                ></div>
              </div>

              <div className="column has-text-left is-8">
                <p className="is-size-6 has-text-grey">
                  <b>
                    <i>En Transito</i>
                  </b>
                </p>
                <p className="is-size-5 has-text-grey">
                  <b>454 paquetes</b>
                </p>
              </div>
            </div>
          </div>
        </nav>

        <div
          style={{
            padding: "2rem",
            backgroundColor: "white",
            borderRadius: "10px",
            marginTop: "3rem",
          }}
        >
          <p className="is-size-6 has-text-grey">KPI Documentos pendientes</p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={dataMixBarchart}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              {/* <Legend
                layout="vertical"
                verticalAlign="middle"
                align="right"
                wrapperStyle={{
                  paddingLeft: "10px",
                }}
                width="120px"
              /> */}
              <Bar
                dataKey="retrasado"
                stackId="a"
                fill="#c8c8c8"
                barSize={14}
                radius={[0, 0, 10, 10]}
              />
              <Bar dataKey="transito" stackId="a" fill="#fecc11" barSize={14} />
              <Bar
                dataKey="arribado"
                stackId="a"
                fill="#41bda5"
                barSize={14}
                radius={[10, 10, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "3rem",
        }}
      >
        <div className="columns">
          <div className="column">
            <div className="has-background-white" style={{ padding: "5px" }}>
              <p
                className="is-size-6 has-text-grey"
                style={{ marginLeft: "20px" }}
              >
                <b>Relación de arribo</b>
              </p>
              <br />
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  layout="vertical"
                  data={dataVerticalChart}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <XAxis type="number" domain={[0, 100]} hide />
                  <YAxis dataKey="name" type="category" />
                  {/* <Tooltip /> */}
                  <Bar
                    dataKey="percent"
                    fill="#30d2d6"
                    minPointSize={5}
                    background={{ fill: "#f8f8f8" }}
                    barSize={20}
                  >
                    <LabelList dataKey="percent" content={CustomizedLabel} />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="column">
            <div className="has-background-white" style={{ padding: "5px" }}>
              <p
                className="is-size-6 has-text-grey"
                style={{ marginLeft: "20px" }}
              >
                <b>Relación de status</b>
              </p>
              <br />
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Legend
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                  />
                  <Pie
                    data={dataPie}
                    innerRadius={60}
                    outerRadius={120}
                    fill="#8884d8"
                    dataKey="value"
                    labelLine={false}
                    label={renderCustomizedLabel}
                  >
                    {dataPie.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
};

export default Dashboard;
